import PropTypes from "prop-types";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { setStationIconsLegendPopup, trackEvent } from "../model/actions";

import "./StationIconButton.scss";

function StationIconButton({
  className,
  legendPopupProps,
  trackEventCategory,
  ...props
}) {
  const dispatch = useDispatch();

  // Open legend on click
  const openLegend = useCallback(
    (evt) => {
      dispatch(setStationIconsLegendPopup(legendPopupProps || {}));
      if (trackEventCategory) {
        dispatch(
          trackEvent(trackEventCategory, "selectStationIcon", "openLegend"),
        );
      }
      evt.stopPropagation();
    },
    [dispatch, legendPopupProps, trackEventCategory],
  );

  return (
    <button
      className={["bt-reset", "trl-icon-button", className || ""].join(" ")}
      onClick={openLegend}
      type="button"
      {...props}
    />
  );
}

StationIconButton.propTypes = {
  className: PropTypes.string,
  legendPopupProps: PropTypes.shape(),
  title: PropTypes.string,
  trackEventCategory: PropTypes.string,
};

export default StationIconButton;
